export default "__VITE_ASSET__CXpky4jz__"